import { render, staticRenderFns } from "./IconRemixicon.vue?vue&type=template&id=5bfd3bf9"
import script from "./IconRemixicon.vue?vue&type=script&lang=js"
export * from "./IconRemixicon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports